import { MetadataSelect } from "@/components/itsm-config/metadata-select";
import {
  useJiraProjects,
  useSnowAssignmentGroups,
  useFreshserviceWorkspaces,
} from "@/hooks/use-itsm-metadata";
import type { ItsmProviderFamily } from "@/lib/types/itsm-config";

interface Props {
  family: ItsmProviderFamily;
  tenantId: string;
  integrationId: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  "aria-label"?: string;
  disabled?: boolean;
}

/** provider_scope picker — Jira project / ServiceNow assignment group /
 *  Freshservice workspace, chosen by provider family. */
export function ScopeSelect({
  family,
  tenantId,
  integrationId,
  value,
  onChange,
  placeholder,
  "aria-label": ariaLabel,
  disabled,
}: Props) {
  const jira = useJiraProjects(
    family === "jira" ? tenantId : undefined,
    integrationId,
  );
  const snow = useSnowAssignmentGroups(
    family === "servicenow" ? tenantId : undefined,
    integrationId,
  );
  const fs = useFreshserviceWorkspaces(
    family === "freshservice" ? tenantId : undefined,
    integrationId,
  );

  const query = family === "jira" ? jira : family === "servicenow" ? snow : fs;
  const label =
    family === "jira"
      ? "project"
      : family === "servicenow"
        ? "assignment group"
        : "workspace";

  return (
    <MetadataSelect
      options={query.data?.options ?? []}
      isLoading={query.isLoading}
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? `Select a ${label}...`}
      aria-label={ariaLabel}
      disabled={disabled}
    />
  );
}
